var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotarization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2412_116543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 14.5H4C4 11.7727 4.94733 11.7727 6.52667 11.7727C10 11.7727 7.33333 8.68182 7.33333 7.1936C7.33333 6.47921 7.61428 5.79409 8.11438 5.28894C8.61448 4.78379 9.29276 4.5 10 4.5C10.7072 4.5 11.3855 4.78379 11.8856 5.28894C12.3857 5.79409 12.6667 6.47921 12.6667 7.1936C12.6667 8.68182 10 11.7727 13.4733 11.7727C15.0527 11.7727 16 11.7727 16 14.5Z",
    fill: "#FBA12B",
    stroke: "#FBA12B",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 16.5H15",
    stroke: "#FBA12B",
    strokeWidth: 1.04167,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2412_116543"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarization);
export default __webpack_public_path__ + "static/media/Notarization.884637a92fe0b8d9bb82dd9d13a5374d.svg";
export { ForwardRef as ReactComponent };